import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { buildUrl } from '../../../utils/CalendarUrlUtil';

const AddToCalendar = ({ className, event, session, magicLink, isLoggedIn, sendCustomClick, buttonType }) => {
    const buttons = [
        ['google', 'add-to-calendar__button--blue', 'Google'],
        ['outlook', 'add-to-calendar__button--purple', 'Outlook'],
        ['ical', 'add-to-calendar__button--red', 'iCal'],
        ['yahoo', 'add-to-calendar__button--violet', 'Yahoo']
    ];

    const clickHandler = (subCategory, ref) => sendCustomClick(buttonType, subCategory, ref);
    return (
        <div className={className}>
            {buttons.map(([nameForBuilder, className, showingName], i) => {
                const buttonRef = useRef();
                return (
                    <a
                        href={buildUrl(event, nameForBuilder, magicLink, isLoggedIn, session)}
                        key={i}
                        onClick={() => clickHandler(showingName, buttonRef)}
                        target="_blank" rel="noreferrer">
                        <button
                            className={`add-to-calendar__button ${className}`}
                            ref={buttonRef}>
                            {showingName}
                        </button>
                    </a>);
            })}
        </div>
    );
};

AddToCalendar.propTypes = {
    className: PropTypes.string,
    event: PropTypes.object,
    magicLink: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    sendCustomClick: PropTypes.func,
    buttonType: PropTypes.string
};

export default AddToCalendar;
